export const LS_SAC_TEMAS =
  "sac_temas_generados";

export const LS_SAC_HASH =
  "sac_hash_step3";

export const createHash = (value) => {
  try {
    return btoa(
      encodeURIComponent(
        JSON.stringify(value)
      )
    );
  } catch (error) {
    console.error(
      "No se pudo generar el hash " +
        "de la secuencia:",
      error
    );

    return null;
  }
};